// MUI
import { Box, Stack } from "@mui/material";

// Components
import LogInButton from "@Settings/Layouts/LogInButton";
import SmartSelector from "@Layouts/components/InputComponents/SmartSelector";

// Types
import { AuthRoleStatus, TSelectedProvider } from "@Settings/types/administrationTools/utils";
import { hasMultipleRoles, hasSomeRoleLoggedIn } from "@Settings/helpers/AdministrationTools/Provider/utils";

type ProviderLoginProps = Readonly<{
	isLoading: boolean;
	isPending: boolean;
	disabled: boolean;
	providers: {
		_id: string;
		provider: string;
		providerName: string;
	}[];
	selectedProvider: Partial<TSelectedProvider> | null;
	// Callbacks
	onLogin: () => void;
	onLogout: () => void;
	onUpdateProvider: (provider: Partial<TSelectedProvider>) => void;
}>;

export default function ProviderLogin(props: ProviderLoginProps) {
	const isLoading = props.isLoading || props.isPending;
	const { onLogin, onLogout = () => {} } = props;

	return (
		<Stack direction={"row"} spacing={3} marginTop={"5px"}>
			<Box width={200}>
				<SmartSelector
					selectBy={"provider"}
					showBy={"providerName"}
					disabled={isLoading}
					options={props.providers ?? []}
					selected={props.selectedProvider}
					loading={isLoading}
					inputProps={{
						placeholder: "Select a provider",
					}}
					listBoxProps={{
						sx: { maxHeight: "220px" },
					}}
					// Callbacks
					onChangeAction={(values) => props.onUpdateProvider(values as Partial<TSelectedProvider>)}
				/>
			</Box>
			<LogInButton
				onClick={hasSomeRoleLoggedIn(props.selectedProvider) && !hasMultipleRoles(props?.selectedProvider) ? onLogout : onLogin}
				disabled={props.disabled}
				isLoading={props.isLoading}
				isLoggedIn={hasSomeRoleLoggedIn(props.selectedProvider as { authRoleStatuses: AuthRoleStatus[] })}
			/>
		</Stack>
	);
}
